export default __webpack_public_path__ + "images/assets/371805e87c9512fe1c0e581ddb699b43.svg";